import cloneDeep from 'lodash/cloneDeep';
export var clone = function (content) { return cloneDeep(content); };
